import { isNonEmptyString } from '@/utils/checks'
import { PrimaryFocus } from '../constant'

export const getPrimaryFocusFilter = (primaryFocus?: PrimaryFocus): string => {
  if (!isNonEmptyString(primaryFocus)) {
    return ''
  }

  if (primaryFocus === PrimaryFocus.MENTAL_HEALTH) {
    return "(primaryFocus:'Mental Health' OR primaryFocus:'Substance Use and Mental Health')"
  }
  if (primaryFocus === PrimaryFocus.SUBSTANCE_USE) {
    return "(primaryFocus:'Substance Use' OR primaryFocus:'Substance Use and Mental Health')"
  }
  if (primaryFocus === PrimaryFocus.SUBSTANCE_USE_AND_MENTAL_HEALTH) {
    return "(primaryFocus:'Mental Health' OR primaryFocus:'Substance Use and Mental Health' OR primaryFocus:'Substance Use')"
  }
  return `primaryFocus:'${primaryFocus}'`
}
